let waiting: HTMLElement | null = null;
let message: HTMLElement | null = null;
let title: HTMLElement | null = null;
let hint: HTMLElement | null = null;
let retry: HTMLButtonElement | null = null;
let retryAction: (() => void) | null = null;
let recovery: HTMLElement | null = null;
let recoveryMessage: HTMLElement | null = null;
let recoveryAttempt: HTMLElement | null = null;

export function showGuestWaiting(cancel: () => void, onRetry?: () => void): void {
  hideConnectionRecovery();
  waiting?.remove();
  waiting = document.createElement('section'); waiting.className = 'guest-waiting';
  waiting.setAttribute('aria-label', '连接进度');
  title = document.createElement('h2'); title.textContent = '正在连接对方';
  message = document.createElement('p'); message.setAttribute('role', 'status'); message.setAttribute('aria-live', 'polite'); message.textContent = '正在发送连接请求…';
  hint = document.createElement('small'); hint.textContent = '连接建立前，不会共享桌面。';
  retryAction = onRetry || null;
  retry = document.createElement('button'); retry.type = 'button'; retry.className = 'retry'; retry.textContent = '重新连接'; retry.hidden = !retryAction;
  retry.onclick = () => { const action = retryAction; action?.(); };
  const button = document.createElement('button'); button.type = 'button'; button.textContent = '取消并返回';
  button.onclick = () => { hideGuestWaiting(); cancel(); };
  waiting.append(title, message, hint, retry, button);
  document.getElementById('view-session')?.append(waiting);
  button.focus();
}

export function updateGuestWaiting(text: string, state: 'idle' | 'online' | 'error' = 'idle'): void {
  if (message) message.textContent = text;
  if (title) title.textContent = state === 'error' ? '连接没有完成' : '正在连接对方';
  if (hint) hint.textContent = state === 'error' ? '可以重新连接，或返回检查设备是否在线。' : '连接建立前，不会共享桌面。';
  if (retry) {
    const shouldShow = state === 'error' && Boolean(retryAction);
    const wasHidden = retry.hidden;
    retry.hidden = !shouldShow;
    if (shouldShow && wasHidden) retry.focus({ preventScroll: true });
  }
}

/** Show the same recoverable surface when an already-running session loses its path. */
export function showGuestRecovery(
  cancel: () => void,
  onRetry?: () => void,
  text = '连接没有响应，已停止自动重试。',
): void {
  showGuestWaiting(cancel, onRetry);
  updateGuestWaiting(text, 'error');
}

/**
 * 已经收到画面后的短暂恢复只显示一条轻量提示，不再覆盖远端画面或抢走
 * 输入焦点。这样用户能知道连接正在自愈，同时仍可观察当前画面状态。
 */
export function showConnectionRecovery(text: string, attempt = 0): void {
  const root = document.getElementById('view-session');
  // 首次建连仍需要完整等待面板和取消入口；轻量提示只服务于已经
  // 收到画面的会话，不能覆盖掉用户尚未完成的连接操作。
  if (!root || waiting) return;
  if (!recovery || !root.contains(recovery)) {
    recovery = document.createElement('div');
    recovery.className = 'session-recovery-banner';
    recovery.setAttribute('role', 'status');
    recovery.setAttribute('aria-live', 'polite');
    recovery.setAttribute('aria-atomic', 'true');

    const indicator = document.createElement('span');
    indicator.className = 'session-recovery-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    recoveryMessage = document.createElement('span');
    recoveryMessage.className = 'session-recovery-message';
    recoveryAttempt = document.createElement('small');
    recoveryAttempt.className = 'session-recovery-attempt';
    recovery.append(indicator, recoveryMessage, recoveryAttempt);
    root.append(recovery);
  }
  recovery.hidden = false;
  if (recoveryMessage) recoveryMessage.textContent = text;
  if (recoveryAttempt) {
    recoveryAttempt.textContent = attempt > 0 ? `自动恢复 · 第 ${attempt} 次` : '自动恢复中';
  }
}

export function hideConnectionRecovery(): void {
  recovery?.remove();
  recovery = null;
  recoveryMessage = null;
  recoveryAttempt = null;
}

export function hideGuestWaiting(): void {
  waiting?.remove();
  waiting = null;
  message = null;
  title = null;
  hint = null;
  retry = null;
  retryAction = null;
  hideConnectionRecovery();
}
